import axios from "axios";
import apiConsts from "./apiconsts";

export const apiBaseUrl = apiConsts.getBaseUrl() + `/api/v2`;

const axiosInstance = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

// request interceptor
axiosInstance.interceptors.request.use(
    function(config) {
        // request data
        return config;
    },
    function(error) {
        return Promise.reject(error);
    },
);

// response interceptor
axiosInstance.interceptors.response.use(
    function(response) {
        // response data
        return response;
    },
    function(error) {
        if (axios.isCancel(error)) {
            return error;
        }
        
        const {status, data} = error.response;
        if (status === 401) {
            
            let redirectUrl = "https://login.ezoic.com/?redirect_url=https%3A%2F%2Fproteus.ezoic.com";
            if (apiConsts.isLocal()) {
                redirectUrl = "https://login.ezoic.com/?redirect_url=https%3A%2F%2Fl.ezoic.com%3A13001"
            }
            
            window.location.href = redirectUrl;
        } else {
            let message = data && data.message;
            console.error(message);
        }
        return Promise.reject(error);
    },
);
  
function Api() {
    return axiosInstance;
}
  
export default Api;